import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";

const ImageCard = ({ combo, onAddToCart }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ padding: 10, outline: "none" }}
    >
      <div
        style={{
          height: 300,
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          boxShadow: hovered
            ? "0 16px 30px rgba(0,0,0,0.2)"
            : "0 12px 25px rgba(0,0,0,0.1)",
          transition: "transform .3s, box-shadow .3s",
          cursor: "pointer",
          transform: hovered ? "scale(1.02)" : "scale(1)",
        }}
      >
        {/* ✅ API image (base64) */}
        <img
          src={combo.dishImage}
          alt={combo.dishName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            padding: 20,
          }}
        >
          <h3 style={{ marginBottom: 150, fontSize: 22 }}>
            {combo.dishName}
          </h3>
          <button
            onClick={onAddToCart}
            style={{
              padding: "8px 16px",
              backgroundColor: "#fff",
              color: "#000",
              border: "none",
              borderRadius: 6,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default function Combos() {
  const [combos, setCombos] = useState([]);
  useEffect(() => {
    const fetchCombos = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
          console.warn("Missing vendorId or authToken in localStorage");
          return;
        }

        const response = await axios.get(
          `https://backend.maamaas.com/food/dish/getbyvendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        // console.log("🌍 Full API Response:", JSON.stringify(response.data, null, 2));

        // 🔎 Find the COMBOS parent
        const combosCategory = response.data.find(
          (item) => item.dishName?.toUpperCase() === "COMBOS"
        );

        if (!combosCategory) {
          // console.warn("❌ No COMBOS category found");
          return;
        }

        // ✅ Get all items with parentId = COMBOS.dishId
        const combosList = response.data.filter(
          (item) => item.parentId === combosCategory.dishId
        );

        // console.log("✅ Resolved Combos Children:", combosList);

        setCombos(combosList); // store in state
      } catch (error) {
        console.error("🚨 Error fetching combos:", error);
      }
    };

    fetchCombos();
  }, []);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="combos-wrapper"
      style={{ maxWidth: 1017, margin: "0 auto", padding: "0px 20px", marginTop: "20px" }}
    >
      <h1
        style={{
          textAlign: "center",
          fontSize: 38,
          fontWeight: 800,
          letterSpacing: 1,
          textTransform: "uppercase",
          textShadow: "0 4px 6px rgba(0,0,0,.1)",
          margin: "0 0 2px",
        }}
      >
        <span style={{ color: "rgb(42 9 71)" }}>Com</span>
        <span style={{ color: "red" }}>bos</span>
      </h1>

      {/* ✅ Slider with combos */}
      <Slider {...settings}>
        {combos.map((combo) => (
          <ImageCard
            key={combo.dishId}
            combo={combo}
            onAddToCart={() => alert(`Added ${combo.dishName} to cart`)}
          />
        ))}
      </Slider>

    </section>
  );
}
